import React, { useEffect, useRef } from 'react'
// import * as am4core from '@amcharts/amcharts4/core'
// import * as am4charts from '@amcharts/amcharts4/charts'
// import am4themes_animated from '@amcharts/amcharts4/themes/animated'

import { create, percent, color } from '@amcharts/amcharts4/core'
import {
	XYChart,
	CategoryAxis,
	ColumnSeries,
	ValueAxis,
} from '@amcharts/amcharts4/charts'

import styles from './BarChart.module.sass'
import themeStyles from 'assets/styles/theme.module.sass'

const { appThemeColor, cardBackgroundColor, appTextColor, borderColor } =
	themeStyles

// am4core.useTheme(am4themes_animated)

const BarChart = (props) => {
	const { chartId, className, data, category, value, ...attributes } = props
	const chart = useRef(null)
	const chartDOM = useRef(null)

	useEffect(() => {
		const xyChart = create(chartDOM.current, XYChart)
		chart.current = xyChart

		return () => {
			xyChart.dispose()
		}
	}, [])
	useEffect(() => {
		if (!data.length || !category || !value) {
			return
		}
		const barChart = chart.current
		const timeout = setTimeout(() => {
			barChart.series.clear()
			barChart.xAxes.clear()
			barChart.yAxes.clear()
			barChart.data = data
			const categoryAxis = barChart.xAxes.push(new CategoryAxis())
			categoryAxis.dataFields.category = category
			categoryAxis.renderer.grid.template.location = 0
			categoryAxis.renderer.minGridDistance = 30
			categoryAxis.renderer.grid.template.strokeOpacity = 0.4
			categoryAxis.renderer.grid.template.stroke = color(borderColor)

			const valueAxis = barChart.yAxes.push(new ValueAxis())
			valueAxis.renderer.grid.template.strokeOpacity = 0.4
			valueAxis.renderer.grid.template.stroke = color(borderColor)

			const series = barChart.series.push(new ColumnSeries())
			series.dataFields.valueY = value
			series.dataFields.categoryX = category
			series.columns.template.tooltipText = 'Value: {valueY}'
			series.stroke = color(appThemeColor)
			series.columns.template.fill = color(appThemeColor)
			series.columns.template.stroke = color(appThemeColor)
			series.columns.template.column.cornerRadiusTopLeft = 4
			series.columns.template.column.cornerRadiusTopRight = 4
			series.columns.template.width = percent(50)
			series.tooltip.getFillFromObject = false
			series.tooltip.background.fill = color(cardBackgroundColor)
			series.tooltip.label.fill = color(appTextColor)
		}, 500)
		return () => {
			clearTimeout(timeout)
		}
	}, [data, category, value])
	return (
		<div
			{...attributes}
			className={`${styles['root'] || ''} ${className || ''}`}
		>
			<div ref={chartDOM} />
		</div>
	)
}

export default BarChart
